var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { staticClass: "form-wrapper" }, [
    _c("div", { staticClass: "form-wrapper-body" }, [
      _c("h3", { staticClass: "form-wrapper-body-title" }, [
        _vm._v("Choose filters")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("div", { staticClass: "label mb-1" }, [_vm._v("Status")]),
          _vm._v(" "),
          _c("select-box", {
            attrs: {
              "data-list": _vm.statuses,
              required: true,
              "default-value": _vm.status,
              "format-callback": function(item) {
                return _vm.capitalize(item)
              }
            },
            on: { selected: _vm.onStatusSelect }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-wrapper-footer" }, [
      _c(
        "button",
        {
          class: ["form-wrapper-footer-button", "primary-btn", "btn-center"],
          style: { marginRight: "1rem" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [_vm._v("\n            Apply\n        ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          class: ["form-wrapper-footer-button", "danger-btn", "btn-center"],
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.reset($event)
            }
          }
        },
        [_vm._v("\n            Clear all\n        ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-187bb23e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-187bb23e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/FilterReceiptsModal.vue
// module id = null
// module chunks = 